var createHubLocale = require('./localeFactory.js')
var backgroundRemoverLocales = require('./backgroundRemoverLocales.js')
var portraitChangerLocales = require('./portraitChangerLocales.js')
var bgPack = backgroundRemoverLocales.ja
var pcPack = portraitChangerLocales.ja

var ARTICLE_BODIES = Object.assign({}, {
  'seedream-ai-image-generator-review': {
    overview: [
      'Seedreamは、アート寄りモデルでよく見られる即座のスタイル化ではなく、リアルな商用ビジュアル向けに設計されています。Seedream 5ならブラウザでオンライン生成でき、DiscordもStable Diffusionのローカル環境も不要です。',
      '私は高速レイアウトツールとして使います。商品配置、ライティング、背景の方向性は通常、数バージョンで明確になります。ガラスの反射や金属のエッジをよりシャープにしたいときは、同じブリーフをFLUXで再実行します。',
      'Midjourneyと比べると、Seedreamはファンタジーの雰囲気よりも商品＋シーン＋ライティングといった商用プロンプトに従います。GPT Imageと比べると、画像内の長い見出しテキストよりもビジュアルシーンが強みです。ECヒーロー画像とライフスタイルポスターが最も始めやすい用途です。'
    ],
    practice: [
      'このレビューでは、30mlスキンケアボトルをAmazonメイン画像、Instagram 4:5商品投稿、クリーンなSKUショットでテストしました。各ラウンドで5〜6バージョン生成し、すぐ使えるものとプロンプト修正が必要なものを確認しました。',
      '有用なパターンはシンプルでした。方向性はSeedream、クライアントがガラスと金属のディテールを重視する場合は仕上げにFLUX、読みやすいプロモテキストが必要な納品物にはGPT Imageです。'
    ],
    compareIntro: '唯一の最良モデルはなく、用途に合うものだけがあります。私のデフォルト構成は、商用商品ビジュアルにSeedream、ハードな商品写真にFLUX、アート探索にMidjourney、テキスト多めのポスターにGPT Imageです。',
    modelFaq: [
      { q: 'SeedreamでEC商品画像を作るには？', a: '商品＋シーン＋ライティング＋用途を書きます。Amazonメイン画像では、まずクリーンな数バージョンを生成し、その後素材と背景を詰めます。' },
      { q: 'SeedreamはAmazonメイン画像に使える？', a: 'はい。白や明るい背景は使えますが、エッジの整えには通常3〜4バージョン必要です。ライフスタイルシーンの方が早く決まりやすいです。' },
      { q: 'SeedreamでShopify用ライフスタイル画像は作れる？', a: 'はい。バナーは16:9、ブランドカラー、ファーストビューの構図をプロンプトに入れ、商品タイルは1:1を使います。' },
      { q: 'ECヒーロー画像を作れるAIツールは？', a: '商用シーンはSeedreamから始めます。よりハードなガラスや金属が必要ならFLUX、読みやすいプロモテキストが必要ならGPT Imageへ切り替えます。' },
      { q: 'Seedream生成で商品ディテールがずれたときの直し方は？', a: 'ブリーフを短くし、商品説明を固定して再生成します。素材がまだ柔らかい場合は、同じ構図をFLUXで仕上げます。' },
      { q: 'Seedream 5とSeedream 4の違いは？', a: '日常の商用作業ではプロンプトスタイルは似ています。新規案件ではSeedream 5を使い、Seedream 4向けに調整した旧プロジェクトの強制移行は不要です。' },
      { q: 'Seedreamでポスター見出しを直接生成できる？', a: '長いプロモ見出しには、Seedreamでベースビジュアルを作り、GPT Imageでテキストレイアウトを行います。一発勝負よりこの分担の方が確実です。' },
      { q: 'Discordは必要？', a: 'いいえ。Seedream、FLUX、Midjourney、GPT ImageはすべてMiral内のブラウザで試せます。' }
    ]
  },
  'flux-ai-image-generator-review': {
    overview: [
      'FLUXは、納品物にハードな商品写真が必要なとき—金属の反射、ガラス、肌の質感、広告風ライティング—に手を伸ばすモデルです。FLUX.2が日常の主力で、Flux Schnellは素早い構図テスト用です。',
      '通常はSeedreamと組み合わせます。Seedreamで構図を素早く固め、FLUXで素材と光を仕上げます。イラスト重視のアート方向なら、FLUXをアートモデルのように無理させずMidjourneyやStable Diffusionへ切り替えます。',
      '画像内に読みやすいプロモコピーが含まれる場合、GPT Imageの方が安全です。クライアントが写真品質を見るとき、FLUXが勝ちます。'
    ],
    compareIntro: 'ハードな商品写真と広告ビジュアルにはFLUX.2、より速いシーン反復にはSeedream、コンセプトアートにはMidjourney、ポスターに明確なテキストが必要ならGPT Imageを使います。',
    modelFaq: [
      { q: 'FLUXで商品写真を作るには？', a: 'レンズ、リムライト、素材、ハードな商品ライティングといった写真語を使います。最終決定の前に数バージョン生成してください。' },
      { q: 'FLUXは商用商品画像に使える？', a: 'はい。クライアントが写真品質を見るとき、金属、ガラス、広告風ライティングに強いです。' },
      { q: 'FLUXでリアルなジュエリー写真は作れる？', a: 'はい。ただし短いプロンプトでは足りません。マクロ、エッジ光、背景、素材詳細を足し、構図の速さはSeedreamと比較します。' },
      { q: 'ハードライトの商品写真を作れるAIツールは？', a: '最終テクスチャはFLUX.2。先にシーン反復を速くしたい場合はSeedreamで構図を下書きします。' },
      { q: 'FLUX生成で素材や反射が柔らかいときの直し方は？', a: 'よりシャープな素材・ライティング語を足して数バージョン再生成し、納品はFlux SchnellではなくFLUX.2を使います。' },
      { q: 'FLUX.2かFlux Schnell？', a: '構図のスクリーニングはSchnell。納品に近づいて最終的な素材品質が必要ならFLUX.2です。' },
      { q: 'FLUXでポスターテキストは扱える？', a: '短いテキストは可能ですが、見出しレイアウトと読みやすいプロモコピーにはGPT Imageの方が確実です。' }
    ]
  },
  'midjourney-alternative-online': {
    overview: [
      'Midjourneyの代替を探す人は、通常3つのうちどれかを求めています。Discordなしのブラウザアクセス、よりスムーズなWebワークフロー、またはアート探索とEC出力を混在させる1つのプロジェクトです。',
      'Midjourneyはコンセプトアート、ファンタジーシーン、スタイル化探索に依然として強いです。Amazonヒーロー画像、ハードな商品写真、読みやすいテキスト入りポスターには、同じMiralワークスペースでSeedream、FLUX、GPT Imageへ切り替えます。',
      'Stable Diffusion 3.5 onlineも、ローカル環境なしでイラスト制御が欲しいときの有用な比較対象です。実用的な流れは、MidjourneyやStable Diffusionで方向性を決め、商用の最終稿はSeedreamかFLUXへ移ることが多いです。'
    ],
    compareIntro: '用途に合わせる：アート探索はMidjourney、速い商用シーンはSeedream、商品写真はFLUX、テキストポスターはGPT Image、オンラインでのイラスト制御はStable Diffusion 3.5。',
    modelFaq: [
      { q: 'DiscordなしでMidjourneyをオンラインで使うには？', a: 'MiralのブラウザワークフローでMidjourneyを開き、そこで数バージョン生成します。その経路ではDiscordボット設定は不要です。' },
      { q: 'ブラウザでMidjourneyは使える？', a: 'はい。セットアップを減らし、横並び比較を速くしたい人がMidjourney代替を探す主な理由です。' },
      { q: 'DiscordなしでMidjourney風のアートは作れる？', a: 'はい。雰囲気はブラウザのMidjourneyで作り、同じプロジェクトで後から商用商品の最終稿が必要ならSeedreamやFLUXへ切り替えます。' },
      { q: 'DiscordなしでEC画像を作れるツールは？', a: '商品シーンはSeedream、ハードな商品写真はFLUX、読みやすいプロモテキストが必要なグラフィックはGPT Imageです。' },
      { q: 'Midjourney代替でアートスタイルがずれたときの直し方は？', a: '1モデルにすべてを押し付けないでください。アート方向はMidjourneyやStable Diffusion、商用最終稿はSeedreamやFLUXへ移します。' },
      { q: 'MidjourneyかStable Diffusion？', a: 'どちらもアート探索に使えます。Midjourneyは雰囲気で勝つことが多く、Stable Diffusionは線とスタイル制御で強い場合があります。' }
    ]
  },
  'gpt-image-generator-guide': {
    overview: [
      'GPT Imageは、納品物に読みやすいテキスト構造が必要なとき—プロモポスター、商品ベネフィットグラフィック、ニュースレターヘッダー、見出しコピー付きソーシャルカバー—の第一選択です。',
      '最も使うワークフローは、SeedreamかFLUXで商品ビジュアルを作り、GPT Imageでテキストレイアウトを行うことです。写真とタイポグラフィを一発で両方狙うより、この分担の方が確実です。',
      '純粋なアート探索やハードな商品写真には、Midjourney、Seedream、FLUXが依然として優れています。GPT Imageはコピーとレイアウトが要件の一部のときに勝ちます。'
    ],
    compareIntro: 'テキストポスターとベネフィットグラフィックにはGPT Image、大きなマーケティングキービジュアルにはQwen Image、速い商品シーンにはSeedream、ベース画像にハードな写真が必要ならFLUXを使います。',
    modelFaq: [
      { q: 'GPT Imageでテキストポスターを作るには？', a: '見出し、サブ見出し、オファー、スタイル、アスペクト比を先に書きます。コピーブロックは短く保ち、レイアウトを読みやすくします。' },
      { q: 'GPT ImageはShopifyバナーに使える？', a: 'はい。見出し、割引、商品名、ブランドカラー、16:9比率をプロンプトに入れ、数パターンのレイアウトを生成します。' },
      { q: 'AI画像で読みやすいテキストは生成できる？', a: 'はい、GPT Imageなら可能です。長い段落や密集した法的文面より、短い構造化プロモコピーの方が向いています。' },
      { q: '商品ベネフィットグラフィックを作れるAIツールは？', a: 'テキストレイアウトはGPT Image。写真品質が重要な場合は、先にSeedreamかFLUXで商品シーンを生成します。' },
      { q: 'GPT Imageポスターで文字化けしたときの直し方は？', a: 'コピーを短くして再生成し、納品前に全語を確認します。ビジュアルは合っていて文字だけ失敗した場合は、ベース画像を残してタイポグラフィだけ作り直します。' },
      { q: 'GPT Imageで商品写真は代替できる？', a: '完全には。商品シーンはSeedreamかFLUXで生成し、GPT Imageでテキストを追加します。' }
    ]
  },
  'qwen-image-generator-review': {
    overview: [
      'Qwen Image 2.0 Proは、より大きなマーケティングビジュアル—キャンペーンポスター、詳細ページヒーロー画像、強い中心ビジュアルの高解像度ソーシャルカバー—が必要なときに有用です。',
      '視覚的インパクトと読みやすいテキストレイアウトのどちらかという問いではGPT Imageと比較します。Qwen Imageは大きなポスター構図で勝つことが多く、GPT Imageは構造化されたプロモコピーで勝ちます。',
      '商品写真の最終稿はFLUXへ、ECシーンの素早い下書きは速度重視ならSeedreamから始めることが多いです。'
    ],
    compareIntro: '大きなマーケティングポスターと高解像度キービジュアルにはQwen Image、テキスト多めのプロモレイアウトにはGPT Image、速い商品シーンにはSeedream、ハードな商品写真にはFLUXを使います。',
    modelFaq: [
      { q: 'Qwen Imageで高解像度ポスターを作るには？', a: '商品やキャンペーンの主題、メイン見出し、ムード、出力サイズを書きます。Qwen Imageは大きなマーケティングキービジュアルに最も強いです。' },
      { q: 'Qwen ImageはEC詳細ページに使える？', a: 'はい。特に強いヒーロービジュアルと2Kレベルのマーケティング画像が必要なときに適しています。' },
      { q: 'Qwenで2Kマーケティング画像は生成できる？', a: 'はい。解像度目標とアスペクト比をブリーフに入れ、公開前に文字エッジを確認します。' },
      { q: '大きなキャンペーンポスターを作れるAIツールは？', a: '大きなポスターのインパクトはQwen Image。構造化されたプロモコピーがビジュアル規模より重要ならGPT Imageへ切り替えます。' },
      { q: 'Qwen Imageポスターで文字が読めないときの直し方は？', a: '見出しを短くし、細かい本文を減らして再生成します。長いベネフィット一覧はGPT Imageでテキストレイアウトを仕上げます。' },
      { q: 'Qwen ImageかFLUX？', a: '大きなキャンペーンビジュアルはQwen Image。ハードな商品写真と素材ディテールはFLUXです。' }
    ]
  },
  'z-image-ai-generator-review': {
    overview: [
      'Z Image Turboは私にとって方向性を見つけるモデルであり、最終納品モデルではありません。広告構図、カラー方向、ソーシャルプロモレイアウトを素早くテストするために使います。',
      '方向性が明確になったら、最終商用ビジュアルはFLUXかSeedreamへ移ります。読みやすいプロモテキストが必要な納品物は、GPT Imageが最後のステップをより確実に処理します。',
      'Flux Schnellと比べると、Z Image Turboはプロモ下書きとキャンペーンカラーテストに有用です。Midjourneyと比べると、アート探索より速い商用反復向けです。'
    ],
    compareIntro: '方向性を素早くテストするにはZ Image Turbo、最終商品写真にはFLUX、速いECシーンにはSeedream、読みやすいテキストが必要なプロモにはGPT Imageを使います。',
    modelFaq: [
      { q: 'Z Image Turboで速い広告コンセプトを作るには？', a: 'まず構図とカラーの方向を3〜5案生成します。最終納品モデルではなく下書きモデルとして扱います。' },
      { q: 'Z Image TurboはSNS広告に使える？', a: '方向性探しやキャンペーンカラーテストならはい。重要なライブアセットはFLUXかSeedreamで仕上げます。' },
      { q: 'Z Imageでキャンペーン下書きは生成できる？', a: 'はい。最終的な素材ディテールより速度が必要なときに有用です。' },
      { q: '広告構図を素早く試せるAIツールは？', a: 'プロモ下書きはZ Image Turbo。商品写真の最終稿はFLUX、読みやすいプロモテキストが必要ならGPT Imageへ移します。' },
      { q: 'Z Image下書きで商品ディテールが弱いときの直し方は？', a: '気に入った構図を固定し、同じブリーフで最終稿をFLUXかSeedreamで再生成します。' },
      { q: 'Z Image TurboかMidjourney？', a: 'アート探索はMidjourney。速い広告とソーシャルプロモ方向はZ Image Turboです。' }
    ]
  },
  'stable-diffusion-online-generator': {
    overview: [
      'Stable Diffusion 3.5 onlineは、モデルインストール、GPU管理、ローカルComfyUIワークフロー構築なしでイラスト風制御が欲しいときの実用的な選択肢です。',
      'アート探索、キャラクターデザイン、スタイル化イラストではMidjourneyとよく比較されます。EC商品の最終稿は、スタイル方向が明確になったらSeedreamかFLUXへ切り替えることが多いです。',
      'プロジェクトに読みやすいプロモテキストやハードな商品写真も必要な場合、Stable Diffusionがビジュアル方向を定義しても、最終ステップはGPT ImageとFLUXの方が優れています。'
    ],
    compareIntro: 'イラストとスタイル制御にはStable Diffusion 3.5 online、雰囲気重視のアート探索にはMidjourney、速い商用シーンにはSeedream、商品写真の最終稿にはFLUXを使います。',
    modelFaq: [
      { q: 'インストールなしでStable Diffusionをオンライン利用するには？', a: 'ブラウザのオンラインSD 3.5ワークフローを使います。最初のテストにローカルモデル、GPU設定、ComfyUIは不要です。' },
      { q: 'ローカルGPUなしでStable Diffusionは使える？', a: 'はい。イラストとキャラクター方向向けのオンライン経路の主な利点です。' },
      { q: 'ブラウザでSD 3.5は動かせる？', a: 'はい。オンラインでスタイルテストを数枚生成し、必要なら商用商品の最終稿はSeedreamやFLUXへ移します。' },
      { q: 'ComfyUIなしでイラストを作れるAIツールは？', a: 'イラストとスタイル制御はStable Diffusion 3.5 online。線より雰囲気が重要ならMidjourneyを使います。' },
      { q: 'Stable Diffusion生成でキャラクターが崩れたときの直し方は？', a: 'バージョン間でアイデンティティ語を短く安定させます。商用最終稿によりハードな写真が必要なら、スタイル方向が承認された後にFLUXへ切り替えます。' },
      { q: 'SDはEC用途でSeedreamの代わりになる？', a: '最終商品写真はSeedreamかFLUXを好みます。SDはイラストとコンセプト方向に向いています。' }
    ]
  },
  'ai-watermark-remover-online': {
    overview: [
      'AI Watermark Remover（AI透かし除去）は、ECやデザイン作業で再利用する前に、ソース画像にロゴ、コーナーマーク、日付スタンプ、繰り返しオーバーレイテキストが残っているときの最初のクリーンアップステップです。',
      'クリーンアップ後、同じアセットはSeedreamかFLUXで新しい商品ビジュアルへ、読みやすいテキスト付きプロモレイアウトが必要ならGPT Imageへ進められます。',
      '文書中心のワークフローでは、Image Crop & Dewarp（文書補正）とHandwriting Eraser（手書き消去）と組み合わせることが多いです。まずスキャンをまっすぐにし、必要なら手書きを消し、その後OCRや再利用前に透かしを除去します。'
    ],
    compareIntro: '既存アセットのクリーンアップにはAI Watermark Remover（AI透かし除去）を使い、次のステップに応じてImage Crop & Dewarp、Handwriting Eraser、Seedream、FLUX、GPT Imageへ続けます。',
    toolFaq: [
      { q: 'EC画像の透かしを除去するには？', a: '鮮明な商品写真をアップロードし、透かしやロゴ領域だけを指定して、書き出し前にエッジを確認します。' },
      { q: 'Shopify商品写真のロゴは消せる？', a: 'はい。ソース画像の権利がある場合です。出品前にクリーンアップ後の商品エッジを検査してください。' },
      { q: '透過透かしも画像から消せる？', a: 'コーナーマークや繰り返しオーバーレイの多くは可能です。大きめの低コントラスト透かしは2回目の処理が必要な場合があります。' },
      { q: 'Shopify画像のコーナーマークを消せるツールは？', a: 'まずAI Watermark Remover。新しい商品ビジュアルはSeedreamやFLUXへ、上にプロモテキストが必要ならGPT Imageへ続けます。' },
      { q: '透かし除去後にテクスチャが繰り返されるときの直し方は？', a: '指定範囲を絞って2回目のクリーンアップを実行します。最初の選択で重要な商品エッジを覆わないでください。' },
      { q: 'Miralツールを1つのワークフローで組み合わせられる？', a: 'はい。一般的な流れはImage Crop & Dewarp、Handwriting Eraser、AI Watermark Remover、その後画像生成です。' }
    ]
  },
  'handwriting-eraser-online': {
    overview: [
      'Handwriting Eraser（手書き消去）は、印刷コンテンツを保持しつつ手書きのマークを除去したい、スキャンしたワークシート、契約書、メモ、テスト用紙向けです。',
      '順序が重要です。スキャンが傾いているか曲がっている場合は通常Image Crop & Dewarp（文書補正）を先に実行し、次にHandwriting Eraser、ソースにオーバーレイマークが残っている場合のみAI Watermark Remover（AI透かし除去）です。',
      'クリーンアップ後、ファイルはOCR、アーカイブ、またはSeedream、FLUX、GPT Imageで新しいビジュアルが必要なデザインワークフローで再利用しやすくなります。'
    ],
    compareIntro: 'Image Crop & Dewarp（文書補正）で文書をまっすぐにした後、Handwriting Eraser（手書き消去）を使い、AI Watermark Remover、OCR、Seedream、FLUX、GPT Imageでの画像生成へ続けます。',
    toolFaq: [
      { q: 'スキャン文書の手書きメモを消すには？', a: '鮮明なスキャンまたは写真をアップロードし、手書き部分だけを指定します。表や罫線の周りは小さな範囲に分けて処理してください。' },
      { q: '印刷文字を消さずに手書きだけを消せる？', a: '手書きが印刷内容に大きく重なっていなければ可能です。出力前に小さな文字と線の端を確認してください。' },
      { q: 'オンラインでテスト用紙の答えを消せる？', a: 'はい。Handwriting Eraserは、印刷された問題を読みやすく保ちつつ、学生の回答や注釈を消すのに有用です。' },
      { q: 'ワークシートの手書き跡をきれいにするツールは？', a: 'スキャンが傾いている場合は先にImage Crop & Dewarp、その後Handwriting Eraser。オーバーレイスタンプが残る場合のみAI Watermark Removerへ続けます。' },
      { q: '手書き消去後に文字がぼやけたときの直し方は？', a: '大きな選択を元に戻し、より小さな範囲で処理します。マスクを手書きに近づけると印刷文字がシャープに保たれます。' },
      { q: '手書き消去後に印刷罫線が切れたときの直し方は？', a: '表の線やフォーム枠をマスクで覆わないでください。密集した注釈の周りは小さめのパスで作業します。' }
    ]
  },
  'image-crop-dewarp-online': {
    overview: [
      'Image Crop & Dewarp（文書補正）は、OCRやクリーンアップの前にスキャン文書画像を自動クロップし、傾きを補正できます。ページ自体の湾曲には湾曲補正を使います。',
      'まっすぐにしてクロップした後、ページにペンマークがある場合は通常Handwriting Eraser（手書き消去）へ、スキャンにオーバーレイスタンプやコーナーロゴが残る場合はAI Watermark Remover（AI透かし除去）へ続けます。',
      'クリーンな文書写真は、プロジェクトが最終的に生成カバーやプロモビジュアルを必要とするとき、Seedream、FLUX、GPT Imageで下流再利用もしやすくなります。'
    ],
    compareIntro: '傾いたスキャンはImage Crop & Dewarp（文書補正）から始め、Handwriting Eraser（手書き消去）とAI Watermark Remover（AI透かし除去）を使い、OCR、アーカイブ、Seedream、FLUX、GPT Imageでの画像生成の前に処理します。',
    toolFaq: [
      { q: 'スキャン文書を自動クロップして傾き補正するには？', a: '四隅が見える鮮明なJPG、PNG、WebPをアップロードし、机の背景を切り取り、傾いた文字列をまっすぐします。' },
      { q: 'オンラインで文書写真をまっすぐできる？', a: 'はい。傾いたスキャンには傾き補正、斜め撮影には遠近補正を使います。' },
      { q: 'ブラウザで湾曲した書籍ページを補正できる？', a: 'はい。綴じ目の湾曲や丸まった紙には湾曲補正を使います。単純な傾き補正とは異なります。' },
      { q: 'OCR前に文書の遠近を直せるツールは？', a: 'まずImage Crop & Dewarp。ページにペン跡やスタンプが残る場合はHandwriting EraserやAI Watermark Removerへ続けます。' },
      { q: '文書写真の遠近歪みを直すには？', a: '四隅を見えたまま遠近補正を実行します。反射や影で端が隠れる場合は、均一な光で撮り直してください。' },
      { q: '自動クロップでページ端が隠れるときの直し方は？', a: '四隅がすべて見えるよう撮り直し、反射を減らし、OCRや手書きクリーンアップの前にもう一度クロップします。' }
    ]
  }
}, bgPack.bodies, pcPack.bodies)

var hub = createHubLocale({
  locale: 'ja',
  articleBodies: ARTICLE_BODIES,
  categories: [
    { key: 'all', label: 'すべての記事', description: 'AI画像モデル、画像ツール、プロンプト、代替サービス、実用チュートリアル。' },
    { key: 'reviews', label: 'レビュー', description: 'Seedream、FLUX、Midjourney、GPT Image、Qwen、Z Image、Stable Diffusion などのAI画像モデルレビュー。' },
    { key: 'how-to-guides', label: '使い方', description: 'AI透かし除去、背景除去、手書き消去、書類写真補正などの操作ガイド。' },
    { key: 'alternatives', label: '代替案', description: 'Midjourney代替、Stable Diffusionオンライン代替などの比較と選び方。' },
    { key: 'ai-model-insights', label: 'AIモデル分析', description: '最新AIモデルの能力、コンテキスト、ツール、費用、活用場面、実際の制約を詳しく分析します。' },
    { key: 'prompt-guides', label: 'プロンプトガイド', description: '文字入りポスター、EC画像、SNSカバー、商品画像向けのプロンプト作成。' }
  ],
  articles: Object.assign({}, {
    'seedream-ai-image-generator-review': { title: 'Seedream 5レビュー：EC商品画像とライフスタイルポスター実測', excerpt: 'Amazonメイン画像、Shopifyバナー、eBay商品画像、Instagram投稿でSeedream 5を実測。プロンプト例とモデル選びも解説。', target: { label: 'Seedream 5を試す' } },
    'flux-ai-image-generator-review': { title: 'FLUX.2レビュー：商品撮影と広告画像、3つの版の選び方', excerpt: '商品写真、広告ビジュアル、商用出力でFLUX.2を検証し、SeedreamやMidjourneyとの使い分けを整理。', target: { label: 'FLUX.2を開く' } },
    'midjourney-alternative-online': { title: 'Midjourney代替：Discordなしで使えるオンライン画像生成ツール5選', excerpt: 'Discordを使わず、ブラウザで商品画像、アート、ポスター、商用ビジュアルを作れるMidjourney代替を比較。', target: { label: 'Midjourneyをオンラインで試す' } },
    'gpt-image-generator-guide': { title: 'GPT Imageプロンプトガイド：文字ポスターと訴求画像の作り方', excerpt: '読みやすい文字入りポスター、EC訴求画像、SNSカバー、ブランドビジュアル向けのGPT Imageプロンプト作成法。', target: { label: 'GPT Imageを開く' } },
    'qwen-image-generator-review': { title: 'Qwen Image 2.0 Proレビュー：マーケティングポスターと商品画像', excerpt: 'Qwen Image 2.0 Proをポスター、商品画像、プロンプト追従、商用ワークフローで実測。', target: { label: 'Qwen Imageを試す' } },
    'z-image-ai-generator-review': { title: 'Z Image Turboレビュー：高速な広告画像とSNSビジュアル', excerpt: 'Z Image Turboを広告ラフ、SNS画像、商品シーン、軽量な商用画像生成でレビュー。', target: { label: 'Z Image Turboを試す' } },
    'stable-diffusion-online-generator': { title: 'Stable Diffusionオンライン代替：ローカル構築なしでSD 3.5を使う', excerpt: 'モデル導入やGPU管理なしでStable Diffusion系の画像生成をオンラインで使う方法を整理。', target: { label: 'Stable Diffusionを開く' } },
    'ai-watermark-remover-online': { title: 'AI透かし除去の使い方：ロゴやウォーターマークをオンラインで削除', excerpt: '画像のロゴ、透かし、重なったマークをオンラインで除去する手順と品質チェックのポイント。', target: { label: '透かし除去を開く' } },
    'handwriting-eraser-online': { title: 'AI手書き消去：答案や文書の手書き文字をオンラインで削除', excerpt: 'プリント内容を残しながら、ワークシート、文書、スキャン画像の手書き跡をAIで消す方法。', target: { label: '手書き消去を開く' } },
    'image-crop-dewarp-online': { title: 'AI文書トリミング補正：傾き、余白、影、透視を修正', excerpt: '文書写真の余白を切り取り、ページをまっすぐにし、影や透視歪みをオンラインで補正。', target: { label: '文書補正を開く' } }
  }, bgPack.articles, pcPack.articles),
  text: {
    home: 'ホーム',
    blog: 'ブログ',
    allArticles: 'すべての記事',
    featuredReading: 'おすすめ記事',
    featureEntry: '無料体験',
    aiImageModels: 'AI画像モデル',
    aiImageTools: 'AI画像ツール',
    categoryNavLabel: 'ブログカテゴリ',
    searchLabel: '記事を検索',
    searchPlaceholder: 'モデル、ツール、プロンプト、シーンを検索',
    searchButton: '検索',
    clearButton: 'クリア',
    popularSearches: 'よく検索される語句：',
    readArticle: '続きを読む',
    viewAllArticles: 'すべての記事を見る',
    previousPage: '前へ',
    nextPage: '次へ',
    allPageTitle: 'AI画像モデルとツールのブログ',
    homeSectionTitle: 'AI画像モデルとツールのブログ',
    homeSectionDescription: 'Seedream、FLUX、Midjourney、GPT Image、Qwen、Z Image、Stable Diffusion、透かし除去、手書き消去、書類補正のレビューと実用ガイド。',
    categoryTitleSuffix: '：AI画像生成と画像編集ガイド',
    defaultDescription: 'AI画像生成、画像ツール、モデルレビュー、代替案、プロンプトワークフローをまとめたMiralガイド。',
    metaTitleAll: 'AI画像生成ブログ：モデルレビュー、プロンプト、画像ツールガイド | Miral',
    viewAllBlog: 'AIブログをすべて見る',
    inArticleLabel: 'この記事の内容',
    quickJump: 'クイック移動',
    promptExample: 'プロンプト例',
    copyPrompt: 'プロンプトをコピー',
    copied: 'コピー済み',
    pros: 'メリット',
    cons: 'デメリット',
    relatedTitle: 'こちらもおすすめ',
    tocTitle: 'ページ内容',
    useNow: '今すぐ使う',
    notFoundTitle: '記事が見つかりません',
    backToBlog: 'ブログに戻る',
    collapse: '閉じる',
    expandMore: 'もっと見る',
    relatedGuidesTitle: '関連ガイド'
  }
})

module.exports = hub
